// extracted by mini-css-extract-plugin
module.exports = {"field":"RadioButton_field__C4Gov","smallDeviceLabel":"RadioButton_smallDeviceLabel__2FcLY"};